<template lang="pug">
div
  app-divider(label="Interessado")
  div.pad5
    div(v-if="interessado.pessoa.isPessoaFisica || (interessado.pessoa.pessoaFisica && interessado.pessoa.pessoaFisica.nome)")
      app-resumo-pessoa-fisica(
        :pessoa="interessado.pessoa.pessoaFisica",
        :isCadastro="true"
      )
      el-row.labelDiv
        el-col(:span="12")
          p
            span.label Email:
            span &nbsp {{interessado.pessoa.email}}
        el-col(:span="12" v-if="isLiberacao")
          p
            span.label Profissão:
            span &nbsp {{interessado.pessoa.pessoaFisica.profissao}}
        el-col(:span="12")
          p
            span.label Estado civil:
            span &nbsp {{getEstadoCivil(interessado.pessoa.pessoaFisica.estadoCivil)}}
        el-col.labelTel(:span="12")
          p
            span.label Telefone(s):
            span(v-if="interessado.pessoa.telefones && !interessado.pessoa.telefones.length") &nbsp {{ '-' }}
            span &nbsp {{ getTelefones(interessado.pessoa.telefones) }}
    div(v-else)
      el-row
        el-col(:span="12")
          p
            span.label CNPJ:
            span &nbsp {{filterNull(interessado.pessoa.pessoaJuridica.cnpj)}}
        el-col(:span="12")
          p
            span.label Razão Social:
            span &nbsp {{filterNull(interessado.pessoa.pessoaJuridica.razaoSocial)}}
        el-col(:span="12")
          p
            span.label Telefone(s):
            span &nbsp {{ getTelefones(interessado.pessoa.telefones) }}
        el-col(:span="12")
          p
            span.label E-mail:
            span &nbsp {{filterNull(interessado.pessoa.email)}}
    app-resumo-endereco(:endereco="interessado.pessoa.endereco")
    br
    div(v-if="hasConjuge")
      div(v-if="isCasado")
        app-divider(label="Dados do cônjuge")
        app-resumo-pessoa-fisica.pad5(
          :pessoa="interessado.conjuge.pessoa.pessoaFisica",
          :isCadastro="true"
          :isProcessoFisicoConjuge="true"
        )
      div(v-if="isViuvo")
        app-divider(label="Dados do cônjuge")
        div.pad5
          p
            span.label CPF:
            span &nbsp {{cpfConjugeIsNonNUll(interessado.conjuge.pessoa.pessoaFisica)}}
          p
            span.label Nome:
            span &nbsp {{filterNull(interessado.conjuge.pessoa.pessoaFisica.nome)}}
          p
            span.label Possui certidão de óbito?
            span &nbsp {{hasCertidao}}
    app-resumo-documentos(v-if="interessado.documentos" :documentos="interessado.documentos")
    div(v-if="hasSocios")
      app-divider(label="Sócios e Representante Legal")
      app-resumo-socios(:socios="interessado.sociosRepresentantesLegais")
      br
</template>
<script>
import _ from 'lodash'

import AppDivider from '@/components/AppDivider'
import AppResumoEndereco from './AppResumoEndereco'
import AppResumoDocumentos from './AppResumoDocumentos'
import AppResumoSocios from './AppResumoSocios'
import AppResumoPessoaFisica from './AppResumoPessoaFisica'
const {estadosCivil} = require('@/utils/' + process.env.ESTADO + '/regrasCentral').default

export default {
  components: {
    AppDivider,
    AppResumoEndereco,
    AppResumoDocumentos,
    AppResumoSocios,
    AppResumoPessoaFisica
  },
  props: {
    interessado: {
      type: Object,
      required: true
    },
    isLiberacao: {
      type: Boolean,
      required: false,
      default: false
    },
    isProcessoFisico: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  methods: {
    filterNull (atributo) {
      if (!atributo || atributo.length === 0) {
        return '-'
      }
      return atributo
    },
    getTelefones (telefones) {
      return telefones.join(', ')
    },
    getEstadoCivil (codigo) {
      const estadoCivil = estadosCivil.filter(estadoCivil => estadoCivil.codigo === codigo)[0]
      return estadoCivil ? estadoCivil.nome : '-'
    },
    getEmail () {
      return this.interessado.pessoa.email ? this.interessado.pessoa.email : this.interessado.pessoa.pessoaJuridica.email ? this.interessado.pessoa.pessoaJuridica.email : '-'
    },
    getOrgaoExpedidor (orgao) {
      return orgao.nome ? (orgao.nome + (orgao.estado ? ' - ' + orgao.estado : '')) : '-'
    },
    getUfRg (pessoa) {
      return pessoa.orgaoExpedidor.estado ? pessoa.orgaoExpedidor.estado : pessoa.orgaoExpedidor.codigo !== null ? pessoa.codigo : '-'
    },
    cpfConjugeIsNonNUll (conjuge) {
      return conjuge?.cpf || '-'
    }
  },
  computed: {
    hasConjuge () {
      return this.interessado?.conjuge?.pessoa?.pessoaFisica?.nome
    },
    isCasado () {
      return this.interessado.pessoa.pessoaFisica &&
        ['UNIAO_ESTAVEL', 'CASADO', 'UNIAO_HOMOAFETIVA']
          .includes(this.interessado.pessoa.pessoaFisica.estadoCivil)
    },
    isViuvo () {
      return this.interessado.pessoa.pessoaFisica &&
        this.interessado.pessoa.pessoaFisica.estadoCivil === 'VIUVO'
    },
    hasSocios () {
      return !_.isEmpty(this.interessado.sociosRepresentantesLegais)
    },
    isEspolio () {
      return this.interessado.espolio ? 'Sim' : 'Não'
    },
    hasCertidao () {
      const hasDocAtestadoObito = this.interessado.documentos.length > 0 && this.interessado.documentos.some(doc => doc.tipo.codigo === 'ATESTADO_OBITO_CONJUGE')
      if (this.interessado?.conjuge?.pessoa?.pessoaFisica?.possuiCertidaoObito !== undefined) {
        return this.interessado.conjuge.pessoa.pessoaFisica.possuiCertidaoObito || hasDocAtestadoObito
          ? 'Sim' : 'Não'
      }
      if (this.interessado?.conjuge?.pessoa?.pessoaFisica?.temCertidaoObito !== undefined) {
        return this.interessado.conjuge.pessoa.pessoaFisica.temCertidaoObito || hasDocAtestadoObito
          ? 'Sim' : 'Não'
      }
      return '-'
    }
  }
}
</script>
<style lang="scss" scoped>
.label {
  font-weight: bold;
}
.pad5 {
  padding: 25px 10px;
}

@media (max-width: 780px) {
  .labelDiv{
    display: flex;
    flex-direction: column;
  }

  .labelTel {
    width: 220px;
  }
}
</style>



// WEBPACK FOOTER //
// src/screens/central/cadastros/para/retificacao/components/resumos/AppResumoInteressado.vue